module.exports = __webpack_public_path__ + "img/menu-icon-open.c43441c0.svg";